import { render } from "./ContactInfo.vue?vue&type=template&id=012d56e0"
const script = {}

import "./ContactInfo.vue?vue&type=style&index=0&id=012d56e0&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__